module.exports = __webpack_public_path__ + "static/media/vegitables_46.9df0779c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_46.csv
// module id = 631
// module chunks = 0